import { AutogenModelOrderSummaryByStopDate, AutogenRowOrderSummaryByStopDate } from "./autogen/AutogenModelOrderSummaryByStopDate";

export class ModelOrderSummaryByStopDate extends AutogenModelOrderSummaryByStopDate<RowOrderSummaryByStopDate> {
    constructor() {
        super(RowOrderSummaryByStopDate);
    }
}

export class RowOrderSummaryByStopDate extends AutogenRowOrderSummaryByStopDate {
}